import PropTypes from 'prop-types'
import React from 'react'
import config from 'SRC/config/config.yaml'

export const Head = ({packages}) =>
  <tr>
    <th>{config.registrationForm.package.head}</th>
    {
      packages.map(item => <th key={item.id}>{item.name}</th>)
    }
  </tr>

Head.propTypes = {
  packages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired
}

Head.defaultProps = {
  packages: []
}
